import equipmentInOut from './equipment_in_out'
import equipmentIoInfo from './equipment_io_info'

const EquipmentInOutServer = {
    equipmentInOut,
    equipmentIoInfo,
};

export default EquipmentInOutServer;
